import React, { useState, useEffect } from 'react';
import {
    MDBCard,
    MDBCardBody,
    MDBCardFooter,
    MDBValidation,
    MDBBtn,
    MDBSpinner
  } from "mdb-react-ui-kit";
import {toast} from "react-toastify";
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createContent } from '../redux/features/contentSlice';

const initialState = {
    title: ""
}
 
const AddEditContent = () => {
    const [contentData, setContentData] = useState(initialState);
    const { error, loading } = useSelector((state) => ({ ...state.content }));
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { title } = contentData;
    const { tourID } = useParams();

    useEffect(() => {
        error && toast.error(error);
    }, [error]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (title){
            const createContentData = { ...contentData };
            dispatch(createContent({ tourID , createContentData, toast, navigate }));
        }
    }

    const onInputChange = (e) => {
        const {name, value} = e.target;
        setContentData({...contentData, [name]: value});

    }

    const handleClear = () => {
        setContentData({ title: ""});
    }
  return (
    <div style={{
        margin: "auto",
        padding: "15px",
        maxWidth: "450px",
        alignContent: "center",
        marginTop: "120px",
    }} className='container'>
        <MDBCard alignment='center'>
            <h5>Adicionar Índice</h5>
            <MDBCardBody>
                <MDBValidation onSubmit={handleSubmit} className="row g-3" noValidate>
                    <div className='col-md-12'>
                        <textarea 
                            placeholder="Entre com o índice"
                            type="text"
                            style={{height: "100px"}}
                            value={title}
                            name="title"
                            onChange={onInputChange}
                            className="form-control"
                            required
                            invalid
                            validation="Entre com o índice"
                        />
                    </div>
                    <div className='col-12'>
                        <MDBBtn style={{ width: "100%" }}>Salvar</MDBBtn>
                        <MDBBtn
                            style={{ width: "100%" }}
                            className="mt-2"
                            color="danger"
                            onClick={handleClear}
                        >
                            Limpar
                        </MDBBtn>
                    </div>
                </MDBValidation>
            </MDBCardBody>
        </MDBCard>
    </div>
  )
}

export default AddEditContent